<template functional>
  <div class="vacancy-card-small__location">
    <template v-if="props.section.work_place_country">
      <div :style="`background-image: url('${props.section.work_place_country.flag}')`"
           class="vacancy-card-small__location-flag"></div>
      {{ props.section.work_place_country.name }}</template><template v-if="props.section.work_place_country && props.section.work_place_city">,</template>
    {{ props.section.work_place_city && props.section.work_place_city.name }}
  </div>
</template>

<script>
  export default {
    name: 'VacancyCardSmallLocation',
    props: {
      section: Object
    },
  }
</script>

<style lang="less">

</style>